import { FC } from 'react';
import { Stack } from '@mantine/core';
import { IconShieldLock } from '@tabler/icons';
import { useTranslation } from 'react-i18next';

import { CardContainer } from '../../cardContainer';
import { IListItemProps, ListItem } from '../../listItem';
import { ROUTES } from '@/containers/routes/constants';

interface ISafetySectionProps {
  filialId?: number;
}

export const SafetySection: FC<ISafetySectionProps> = ({ filialId }) => {
  const { t } = useTranslation();

  // Меню безопасности
  const safetyMenu: IListItemProps = {
    withCheck: false,
    items: [
      {
        name: t('filialSecurity.ipSecurity'),
        link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.common.security}`
      },
      {
        name: t('filialSecurity.passwordSecurity'),
        link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.common.security}`
      }
    ]
  };

  return (
    <CardContainer sectionName={t('profile.safety')} Icon={IconShieldLock}>
      <Stack gap="11px" sx={{ width: '100%' }}>
        <ListItem items={safetyMenu.items} withCheck={safetyMenu.withCheck} />
      </Stack>
    </CardContainer>
  );
};
